import React, { Component } from "react";
import WorkItem from "./WorkItem";
import Image from "../../assets/img/work/avis.jpg";

class Avis extends Component {
  componentDidMount() {
    this.item.componentDidMount();
  }

  enterTransition = time => {
    this.item.enterTransition(time);
  };

  exitTransition = time => {
    this.item.exitTransition(time);
  };

  render = () => {
    return (
      <WorkItem
        ref={item => (this.item = item)}
        title="Avis"
        description={`Car rental manegement SPA (single page application) for baltic countries. Application’s design is based
        on
        Gantt diagram with a complex dynamic UI and backend system integration. The greatest challenge was to
        cope
        with a large datasets in frontend to keep end user experiance smooth and performative. Our part:
        requirements analysis, backend and frontend development, automated testing.`}
        image={Image}
        iconList={["react", "nodejs", "php", "mysql"]}
      />
    );
  };
}

export default Avis;



// WEBPACK FOOTER //
// ./src/components/Work/Avis.js